<template>
  <div>
    <el-dialog
      :before-close="handleClose"
      :visible.sync="details.dialogVisible"
      append-to-body
      title="已学习完成人员"
      width="65%"
    >
      <div class="content-box">
        <div class="table-box">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            tooltip-effect="dark"
          >
            <el-table-column
              align="center"
              label="序号"
              type="index"
              width="60"
            >
            </el-table-column>
            <el-table-column
              align="center"
              label="姓名"
              prop="name"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              align="center"
              label="已获课时"
              prop="classHourTotal"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              align="center"
              label="学习时间"
              prop="finishTime"
              show-overflow-tooltip
            >
            </el-table-column>
          </el-table>
        </div>

        <Page
          v-if="tableData.length > 0"
          :current="params.pageNo"
          :page-size="params.pageSize"
          :total="total"
          class="common_page_box"
          show-total
          @on-change="changePage"
        ></Page>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关闭</el-button>
        <!--        <el-button type="primary" @click="submitBtn">确 定</el-button>-->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  dwEnrollPersonsList,
  dwFinishStudyPersonsList,
} from "@/api/home/guild";

export default {
  props: {
    details: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tableData: [],
      multipleSelection: [],
      xh_userInfo: {},
      total: 0,
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      form: {
        name: "",
        confirm: "",
      },
      confirmList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "待缴费",
          value: 0,
        },
        {
          label: "缴费成功",
          value: 1,
        },
      ],
    };
  },
  watch: {
    details: {
      handler(newVal, oldVal) {
        if (newVal.dialogVisible) {
          this.initData();
        }
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    toSearch() {
      this.params.pageNo = 1;
      this.initData();
    },
    toReset() {
      this.form = {};
      this.params.pageNo = 1;
      this.initData();
    },
    changePage(e) {
      this.params.pageNo = e;
      this.initData();
    },
    initData() {
      this.xh_userInfo = JSON.parse(this.$Cookies.get("xh_userInfo"));
      console.log("this.details", this.details);
      let params = {
        courseId: this.details.courseId,
        company: this.xh_userInfo.user.dwmc,
        token: this.xh_userInfo.token,
      };
      dwFinishStudyPersonsList({
        ...params,
        ...this.params,
        ...this.form,
      }).then((res) => {
        if (res.code == 0 && res.result) {
          this.tableData = res.result ? res.result.records : [];
          this.total = res.result.total;
        }
      });
    },
    handleClose() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style lang="scss" scoped>
.content-box {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  .search_box {
    display: flex;
    flex-wrap: wrap;
    font-size: 14px;
    margin: 20px 0;

    > div {
      margin: 10px;
      white-space: nowrap;
      cursor: pointer;
    }

    .btn1 {
      background: linear-gradient(270deg, #2d85e2 2%, #5b43df 100%);
      color: #fff;
      padding: 5px 15px;
    }

    .btn2 {
      background: #767676;
      color: #fff;
      padding: 5px 15px;
    }
  }

  .table-box {
    width: 100%;
  }
}
</style>
